import { $eq as __eq, createExpressionOperator } from "../../_predicates";
const $eq = createExpressionOperator(__eq);
export {
  $eq
};
